<template>
  <div class="scrollable-container no-horizontal-scroll" style="margin-top: 8px;">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="tratamientosHallazgosAdicionales.length > 0">
      <div v-for="(lst, index) in tratamientosHallazgosAdicionales" :key="index"
          style="padding-left: 22px;">
      <div  style="border-left: 1.5px solid #8DD2DD;">
        <b-row>
          <b-col class="col-lg-10">
            <div class="d-flex align items-center" style="height: 30px;">
              <em class="padecimientoCara text-left" style="width: 20px; margin-left: -8px"/>
              <p class="letterSize m-2" style="color: #4C82AA;"> {{ lst.padecimiento}}</p>
            </div>
            <hr style=" margin-top: 0px; background-color: #D6E7F3 ; width: 120%">
          </b-col>
          <b-col class="col-lg-2 text-right">
    <!--        <b-button id=miBoton size="sm" variant="outline-ligth"
                      v-b-tooltip.hover.lefttop.v-light
                      title="Enviar a prioridad clínica"
                      @click="enviarAPrioridadClinica(lst, index)"
            ><em class="starCircle2 " style="width: 12px;"/>
            </b-button>-->
            <b-button id=miBoton size="sm" variant="outline-ligth"
                      v-b-toggle="'collapseHall-'+index"
            ><b-icon
                style="color: #4FB0B7;  font-size: 10px; height: 13px"
                icon="chevron-down"
            ></b-icon>
            </b-button>
          </b-col>
        </b-row>
          <b-collapse :id="'collapseHall-'+index"  :accordion="'my-accordion99' + index" role="tabpanel">
            <div v-for="(ods, indice) in lst.dientes" :key="indice" >
              <div v-if="ods.tratamientos.filter(t => t.clasificacion === 2).length > 0
                    || ods.tratamientosKits.filter(t => t.clasificacion === 2).length > 0">
              <b-row >
                <b-col cols="10" >
                  <em class="lineaOd"></em>
                  <span class="letterSize" style="color: #17A2B8"> Órgano dental {{ods.numeroDiente}}</span></b-col>
                <b-col class="text-left"  cols="2">
                  <b-button :id="'miBoton' + indice" size="sm" variant="outline-ligth"
                            v-b-tooltip.hover.lefttop.v-light
                            :title="ods.mostrarPrecios ? 'Ocultar precios' : 'Mostrar precios'"
                            @click="ods.mostrarPrecios = !ods.mostrarPrecios"
                  ><em class="monedaVerde " style="width: 18px;"/>
                  </b-button>
                  <b-button id=miBoton size="sm" variant="outline-ligth"
                            v-b-tooltip.hover.lefttop.v-light
                            title="Enviar a prioridad clínica"
                            @click="enviarAPrioridadClinica(ods)"
                  ><em class="starCircle2 " style="width: 18px;"/>
                  </b-button>
                  <b-button id=miBoton size="sm" variant="outline-ligth"
                            v-b-toggle="'collapTratam-'+ods.idDiente"
                  ><b-icon
                      style="color: #4FB0B7;  font-size: 10px; height: 13px"
                      icon="chevron-down"
                  ></b-icon>
                  </b-button>
                </b-col>
              </b-row>




              <b-collapse :id="'collapTratam-'+ ods.idDiente"  :accordion="'my-accordionInterno' + indice" role="tabpanel">

                <b-card-body style="border: 1px solid #d6e7f3; border-radius: 16px; width: 94%; margin-left: 24px" v-if="ods.tratamientos.length > 0 ">
                  <b-table-simple v-if="ods.mostrarPrecios" >
                    <b-thead class="columnasTablaSinColor text-center">
                      <b-tr>
                        <b-th class="tableTh letterSize text-left">tratamiento</b-th>
                        <b-th class="tableTh letterSize">Cantidad</b-th>
                        <b-th class="tableTh letterSize">Precio unitario</b-th>
                        <b-th class="tableTh letterSize" v-if="existePlan">Subtotal</b-th>
                        <b-th class="tableTh letterSize" v-if="existePlan">Descuento plan</b-th>
                        <b-th class="tableTh letterSize"
                             v-if="aplicaPromocionesTxHallazgosAdicionales" >
                          Descuento promo
                        </b-th>
                        <b-th class="tableTh letterSize">Total</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody  >
                      <b-tr v-for="(lista, ind1) in ods.tratamientos.filter(t => t.clasificacion === 2)" :key="ind1" class="text-center">
                        <b-td class=" letterSize text-left">{{ lista.tratamiento }}</b-td>
                        <b-td class=" letterSize"> {{lista.cantidadMaxima}}   </b-td>
                        <b-td class=" letterSize"> <span > {{lista.precioUnitario | monedaEntero}}</span></b-td>
                        <b-td class=" letterSize" v-if="existePlan">{{ lista.subtotal | monedaEntero }}</b-td>
                        <b-td class=" letterSize" v-if="existePlan">{{ lista.montoDescuentoUnitario | monedaEntero }}
                          <div
                              v-for="(item, index) in lista.lstCalcDesc"
                              :key="index"
                          >
                            <strong v-if="item.tipoDescuentoPlan === 'PORCENTAJE'" style="font-size: 0.60rem;" class=" text-muted">
                              <span   v-if="item.idPlanValePaciente !== null "> ({{index+1}}) {{ item.porcentajeDescuentoPlan}}% : {{ item.montoDescuentoVale | moneda}}</span>
                              <span  v-else> ({{index+1}}) {{ item.porcentajeDescuentoPlan}}% : {{ item.montoDescuentoPlan | moneda}}</span>
                            </strong>
                            <strong v-if="item.tipoDescuentoPlan === 'MONTO'" style="font-size: 0.60rem;" class=" text-muted">({{index+1}}) MONTO DESCUENTO: {{ item.montoDescuentoPlan | moneda}}</strong>
                          </div>
                        </b-td>
                      <b-td class=" letterSize" v-if="aplicaPromocionesTxHallazgosAdicionales">
                        <TagPromocionHallazgosAdicionalesKits v-if="lista.promocion === null"
                                        :promociones.sync="promociones"
                                        :tratamiento.sync="ods"
                                        :agrupadoPorOd="false"
                                        :indexTratamiento="ind1"
                        ></TagPromocionHallazgosAdicionalesKits>
                        <span v-if="lista.promocion !== null" :title="lista.promocion != null ? lista.promocion.idPromocion+'-'+lista.promocion.promocion:''">
                          {{lista.descuentoPromo | monedaEntero}}
                        </span>
                        <em v-if="lista.promocion !== null && lista.promocion.promocionForzosa === false "
                            style="cursor: pointer"
                            v-b-tooltip.hover.lefttop.v-light
                            title="Quitar promoción"
                            class="quitarPromo" @click="quitarPromo(ods, false)"
                        ></em>
                      </b-td>
                        <b-td class=" letterSize">
                          <p class="m-0 bodyTxt">{{ (lista.total) | monedaEntero}}</p>
                          <span
                              v-for="(item, index) in lista.lstCalcDesc"
                              :key="index"
                          >
                    <strong v-if="item.tipoDescuentoPlan == 'COPAGO'" style="font-size: 0.60rem;" class=" text-muted">({{index+1}}) COPAGO FIJO: {{ item.montoCopagoFijo | moneda}}</strong><br>
                        </span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <b-table-simple v-else >
                    <b-thead class="columnasTablaSinColor text-center">
                      <b-tr>
                        <b-th class="tableTh letterSize text-left">tratamiento</b-th>
                        <b-th class="tableTh letterSize">Cantidad</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(lista, ind1) in ods.tratamientos.filter(t => t.clasificacion === 2)" :key="ind1" class="text-center">
                        <b-td class=" letterSize text-left">{{ lista.tratamiento }}</b-td>
                        <b-td class=" letterSize"> {{lista.cantidadMaxima}}   </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-card-body>

                <br/>
                <b-card-body style="border: 1px solid #d6e7f3; border-radius: 16px; width: 94%; margin-left: 24px" v-if="ods.tratamientosKits.length > 0">

                  <div >
                    <b-row class="columnasTablaSinColor text-center">
                        <b-col class="tableTh letterSize text-left">tratamiento</b-col>
                        <b-col class="tableTh letterSize">Cantidad</b-col>

                    </b-row>

                      <div v-for="(listaKits, ind2) in ods.tratamientosKits.filter(od => od.idKitTratamiento !== null && od.clasificacion == 2)"
                           :key="ind2" class="text-center">
                        <b-row>
                          <b-col cols="8" class=" letterSize text-left ">
                            <em class="kit_svg"/>
                            {{ listaKits.nombreKit }}
                          </b-col>
                          <b-col class=" letterSize"> 1 </b-col>
                          <b-col class=" letterSize">
                            <b-button id=miBoton2 size="sm" variant="outline-ligth"
                                      v-b-toggle="'collapKits-'+ listaKits.idKitTratamiento"
                            ><b-icon
                                style="color: #4FB0B7;  font-size: 10px; height: 13px"
                                icon="chevron-down"
                            ></b-icon>
                            </b-button>
                          </b-col>

                        </b-row>

                        <b-collapse :id="'collapKits-'+ listaKits.idKitTratamiento"  :accordion="'my-accordionInternoKits' + ind2" role="tabpanel">
                          <b-table-simple v-if="ods.mostrarPrecios">
                            <b-thead class="columnasTablaSinColor text-center">
                              <b-tr>
                                <b-th class="tableTh letterSize text-left">tratamiento</b-th>
                                <b-th class="tableTh letterSize">Cantidad</b-th>
                                <b-th class="tableTh letterSize">Precio unitario</b-th>
                                <b-th class="tableTh letterSize" v-if="existePlan">Subtotal</b-th>
                                <b-th class="tableTh letterSize" v-if="existePlan">Descuento plan</b-th>
                                <b-th class="tableTh letterSize"
                                      v-if="aplicaPromocionesTxHallazgosAdicionales" >
                                  Descuento promo
                                </b-th>
                                <b-th class="tableTh letterSize">Total</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr v-for="(lista, ind1) in listaKits.tratamientos" :key="ind1" class="text-center">
                                <b-td class=" letterSize text-left">{{ lista.tratamiento }}</b-td>
                                <b-td class=" letterSize"> {{lista.cantidadMaxima}}   </b-td>
                                <b-td class=" letterSize"> <span > {{lista.precioUnitario | monedaEntero}}</span></b-td>
                                <b-td class=" letterSize" v-if="existePlan">{{ lista.subtotal | monedaEntero }}</b-td>
                                <b-td class=" letterSize" v-if="existePlan">{{ lista.descuentoPlan | monedaEntero }}
                                  <div
                                      v-for="(item, index) in lista.lstCalcDesc"
                                      :key="index"
                                  >
                                    <strong v-if="item.tipoDescuentoPlan === 'PORCENTAJE'" style="font-size: 0.60rem;" class=" text-muted">
                                      <span   v-if="item.idPlanValePaciente !== null "> ({{index+1}}) {{ item.porcentajeDescuentoPlan}}% : {{ item.montoDescuentoVale | moneda}}</span>
                                      <span  v-else> ({{index+1}}) {{ item.porcentajeDescuentoPlan}}% : {{ item.montoDescuentoPlan | moneda}}</span>
                                    </strong>
                                    <strong v-if="item.tipoDescuentoPlan === 'MONTO'" style="font-size: 0.60rem;" class=" text-muted">({{index+1}}) MONTO DESCUENTO: {{ item.montoDescuentoPlan | moneda}}</strong>
                                  </div>
                                </b-td>
                                <b-td class=" letterSize" v-if="aplicaPromocionesTxHallazgosAdicionales">
                                  <TagPromocionHallazgosAdicionalesKits v-if="lista.promocion === null"
                                                                    :promociones.sync="promociones"
                                                                    :tratamiento.sync="listaKits"
                                                                    :agrupadoPorOd="false"
                                                                    :indexTratamiento="ind1"
                                  ></TagPromocionHallazgosAdicionalesKits>
                                  <span v-if="lista.promocion !== null" :title="lista.promocion != null ? lista.promocion.idPromocion+'-'+lista.promocion.promocion:''">
                                      {{lista.descuentoPromo | monedaEntero}}
                                  </span>
                                  <em v-if="lista.promocion !== null && lista.promocion.promocionForzosa === false "
                                      style="cursor: pointer"
                                      v-b-tooltip.hover.lefttop.v-light
                                      title="Quitar promoción"
                                      class="quitarPromo" @click="quitarPromoKits(listaKits, ind1)"
                                  ></em>
                                </b-td>
                                <b-td class=" letterSize">
                                  <p class="m-0 bodyTxt">{{ (lista.total) | monedaEntero}}</p>
                                  <span
                                      v-for="(item, index) in lista.lstCalcDesc"
                                      :key="index"
                                  >
                                    <strong v-if="item.tipoDescuentoPlan == 'COPAGO'" style="font-size: 0.60rem;" class=" text-muted">({{index+1}}) COPAGO FIJO: {{ item.montoCopagoFijo | moneda}}</strong><br>
                                 </span>
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>

                          <b-table-simple v-if="!ods.mostrarPrecios">
                            <b-thead class="columnasTablaSinColor text-center">
                              <b-tr>
                                <b-th class="tableTh letterSize text-left">tratamiento</b-th>
                                <b-th class="tableTh letterSize">Cantidad</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr v-for="(lista, ind1) in listaKits.tratamientos" :key="ind1" class="text-center">
                                <b-td class=" letterSize text-left">{{ lista.tratamiento }}</b-td>
                                <b-td class=" letterSize"> {{lista.cantidadMaxima}}   </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </b-collapse>

                      </div>








                  </div>
                </b-card-body>
              </b-collapse>
              </div>
              <div v-else class="text-center">
                <p style="font-size: .8em;">Sin hallazgos adicionales</p>
              </div>
            </div>



          </b-collapse>

        </div>
    </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center" style="height: 55vh;">
      <p style="font-size: .8em;">Sin hallazgos adicionales</p>
    </div>
  </div>
</template>


<script>
import TagPromocionHallazgosAdicionalesKits from "@/version5/TagPromocionHallazgosAdicionales";
export default {
  name: "TablaHallazgosAdicionales",
  components: {
    TagPromocionHallazgosAdicionalesKits
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  props: {
    tratamientosHallazgosAdicionales: Array,
    existePlan: Boolean,
    aplicaPromocionesTxHallazgosAdicionales: Boolean,
    promociones:Array,
    aplicaPromocionesTxHallazgosAdicionalesKits:Boolean
  },
  methods: {
    enviarAPrioridadClinica(tratamientos){

      this.$emit('enviarAPrioridad', tratamientos)

    },
    quitarPromo(item){
      this.$emit('montosByRetiroPromo', item)
      if (item.tratamientos[0].idKitTratamiento == null){
        item.tratamientos[0].inversionTotal += item.tratamientos[0].promocion.promoDescPesos;
        let descPromo = 0
        item.tratamientos.forEach(t => {
          if (t.promocion != null){
            t.total += t.promocion.promoDescPesos;
            t.promocion = null
            t.descuentoPromo = 0;
          }
          descPromo += t.descuentoPromo;
        })
        item.tratamientos[0].promocion = null;
        item.tratamientos[0].descuentoPromo = descPromo;
      }
    },
    quitarPromoKits(item, index){
      this.$emit('montosByRetiroPromo', item.tratamientos[index])
      if (item.tratamientos[index].idKitTratamiento != null){
        item.tratamientos[index].inversionTotal += item.tratamientos[index].promocion.promoDescPesos;
        let descPromo = 0
        let t = item.tratamientos[index];
        if (t.promocion != null){
          t.total += t.promocion.promoDescPesos;
          t.promocion = null
          t.descuentoPromo = 0;
        }
        descPromo += t.descuentoPromo;
        item.tratamientos[index].promocion = null;
        item.tratamientos[index].descuentoPromo = descPromo;
      }
    }
  }
}
</script>

<style scoped>
.scrollable-container {
    overflow-y: auto; 
    min-height: 55vh;
  }
.letterSize{
  font-size: .8em !important;
}
.tableTh{
  border-bottom: 0px solid;
  border-top: 0px solid;
}
#miBoton:active {
  background: #ffffff;
  color: white;
}
#miBoton {
  border-radius: 20px;
}
</style>
